"use client"

import type { CategoryExpressProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const CategoryExpress: ComponentConfig<CategoryExpressProps> = {
  label: "Tamda One | Category Express",
  fields: {
    title: {
      label: "Title",
      type: "text",
      placeholder: "DANH MỤC ĐA DẠNG CỦA CHÚNG TÔI",
    },
    items: {
      label: "Items",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.name || `Item ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
        name: {
          label: "Name",
          type: "text",
        },
        link: {
          label: "Link",
          type: "text",
        },
        isViewAll: {
          label: "Is View All",
          type: "select",
          options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
          ],
        },
      },
      defaultItemProps: {
        image: "",
        name: "",
        link: "",
        isViewAll: false,
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "DANH MỤC ĐA DẠNG CỦA CHÚNG TÔI",
    items: [],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { CategoryExpressItem, CategoryExpressProps } from "@/types/types"
